import { useState } from "react";
import { PrimitiveDialogForm } from "../../lib/form/layout";
import { Location } from "../../lib/api/generalContract";
import { Trader, Customer } from "../../lib/api/reports";
import { DirectSale } from "@/lib/api/directSales";
import { CreateDynamicForm, UpdateDynamicForm } from "./forms";

export function CreateFormModal({
  customers,
  traders,
  locations,
}: {
  locations: Location[];
  customers: Customer[];
  traders: Trader[];
}) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <PrimitiveDialogForm
      className="max-w-[98%] h-[98%]"
      isOpen={isOpen}
      onDialogChange={setIsOpen}
      buttonLabel={"Create Direct Sale"}
      dialogTitle={"Create Direct Sale"}
      form={
        <CreateDynamicForm
          onCloseForm={setIsOpen}
          locations={locations}
          customers={customers}
          traders={traders}
        />
      }
    />
  );
}

export function UpdateFormModal({
  isOpen,
  onDialogChange,
  traders,
  customers,
  locations,
  updatedFormData,
}: {
  isOpen: boolean;
  onDialogChange: any;
  locations: Location[];
  customers: Customer[];
  traders: Trader[];
  updatedFormData: DirectSale | null;
}) {
  return (
    <PrimitiveDialogForm
      className="max-w-[98%] h-[98%]"
      isOpen={isOpen}
      onDialogChange={onDialogChange}
      dialogTitle={"Update Direct Sale"}
      form={
        <UpdateDynamicForm
          onCloseForm={onDialogChange}
          locations={locations}
          customers={customers}
          traders={traders}
          updatedFormData={updatedFormData}
        />
      }
    />
  );
}
